var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatisticsAlluserImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "url(#paint0_linear_6391_59926)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6391_59926)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7675 26.1513H14.3584C13.853 26.1513 13.4429 25.7305 13.4429 25.2119V13.9394C13.4429 13.4208 13.853 13 14.3584 13H30.8388C31.3442 13 31.7543 13.4208 31.7543 13.9394V18.6363H29.9232V14.8788H15.274V24.2726H20.7675V26.1513Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0076 28.0301C26.3058 28.0301 24.0608 27.4298 22.5986 26.4219C22.5986 27.1227 22.5986 27.5848 22.5986 28.0301C22.5986 29.5866 25.468 30.8482 29.0076 30.8482C32.5472 30.8482 35.4167 29.5866 35.4167 28.0301C35.4167 27.5848 35.4167 27.1227 35.4167 26.4219C33.9545 27.4298 31.7095 28.0301 29.0076 28.0301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0076 32.7269C26.3058 32.7269 24.0608 32.1266 22.5986 31.1187C22.5986 31.8194 22.5986 32.2816 22.5986 32.7269C22.5986 34.2834 25.468 35.545 29.0076 35.545C32.5472 35.545 35.4167 34.2834 35.4167 32.7269C35.4167 32.2816 35.4167 31.8194 35.4167 31.1187C33.9545 32.1266 31.7095 32.7269 29.0076 32.7269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5997 21.1462C22.2278 20.3937 23.1873 19.7794 24.4069 19.3463C24.2961 18.4201 23.5325 17.6968 22.5986 17.6968C21.5887 17.6968 20.7675 18.5394 20.7675 19.5755C20.7675 20.2331 21.0998 20.8108 21.5997 21.1462Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0076 26.1514C32.5472 26.1514 35.4167 24.8897 35.4167 23.3333C35.4167 21.7769 32.5472 20.5151 29.0076 20.5151C25.468 20.5151 22.5986 21.7769 22.5986 23.3333C22.5986 24.8897 25.468 26.1514 29.0076 26.1514Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6391_59926",
    x1: 7.94287,
    y1: 7,
    x2: 37.4429,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E72E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#825EE4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6391_59926"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.9737,
    height: 22.5451,
    fill: "white",
    transform: "translate(13.4429 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticsAlluserImg);
export default __webpack_public_path__ + "static/media/statistics-alluser-img.e45eff269fae4519b588751c2a2928b2.svg";
export { ForwardRef as ReactComponent };